module.exports = __webpack_public_path__ + "img/helpPatientsS.69445b05.svg";